import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
import trash2Fill from '@iconify/icons-eva/trash-2-fill';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
import closeOutline from '@iconify/icons-eva/close-outline';
import checkmarkFill from '@iconify/icons-eva/checkmark-fill';
// material
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import {
  Box,
  Toolbar,
  Tooltip,
  IconButton,
  Typography,
  OutlinedInput,
  InputAdornment
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';
// ----------------------------------------------------------------------
const useStyles = makeStyles((theme) => ({
  buttonS: {
    padding: '10px 20px',
    fontFamily: 'Oregano, cursive',
    color: '#fff',
    fontSize: '16px',
    fontWeight: 600,
    background: '#f58081',
    letterSpacing: 1,
    borderRadius: 5,
    cursor: 'pointer',
    textDecoration: 'none',
    boxShadow: '0 10px 25px 0 rgb(1 45 126 / 15%)',
    opacity: 1,
    transition: 'all 0.1s ease-in',
    border: 'none',
    '&:hover': {
      opacity: 0.9
    }
  },
  buttonP: {
    padding: '5px',
    fontFamily: 'Oregano, cursive',
    fontSize: '14px',
    fontWeight: 600,
    letterSpacing: 1,
    borderRadius: 15,
    cursor: 'pointer',
    textDecoration: 'none',
    boxShadow: '0 10px 25px 0 rgb(1 45 126 / 15%)',
    opacity: 1,
    transition: 'all 0.1s ease-in',
    border: '1px solid #f78181',
    margin: 5,
    '&:hover': {
      opacity: 0.9
    }
  }
}));

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 120,
  display: 'flex',
  padding: '10px 10px'
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

// ----------------------------------------------------------------------

UserListToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func
};

export default function UserListToolbar({
  numSelected,
  isPayment,
  filterName,
  onFilterName,
  holder,
  click,
  click1,
  clickDelete,
  clickValide,
  clickRefused,
  classNameButton,
  btnName,
  select,
  setSelect,
  paymentPayment,
  isValide,
  isRefuse,
  isArchive
}) {
  const { t } = useTranslation();
  const userDetails = JSON.parse(localStorage.getItem('user'));

  const listPayment = [
    {
      id: 1,
      name: t('nounou')
    },
    {
      id: 2,
      name: t('chauffeur')
    },
    {
      id: 3,
      name: `${t('nounou')} ${t('et')} ${t('chauffeur')}`
    }
  ];

  const classes = useStyles();
  const result = () => {
    if (paymentPayment) {
      return (
        <Box style={{ flex: 1 }}>
          {clickValide && isValide && (
            <IconButton
              onClick={clickValide}
              size="small"
              aria-label="upload picture"
              component="span"
            >
              <CheckIcon style={{ color: '#2ab7bf' }} />
            </IconButton>
          )}
          {clickRefused && isRefuse && (
            <IconButton
              onClick={clickRefused}
              size="small"
              aria-label="upload picture"
              component="span"
              style={{ margin: '0px 10px' }}
            >
              <CloseIcon style={{ color: 'red' }} />
            </IconButton>
          )}
          {clickDelete && isArchive && (
            <IconButton
              onClick={clickDelete}
              size="small"
              aria-label="upload picture"
              component="span"
            >
              <DeleteIcon style={{ color: '#ec8181' }} />
            </IconButton>
          )}
        </Box>
      );
    }
    if (!isPayment) {
      return (
        <button className={classes.buttonS} onClick={click}>
          {btnName}
        </button>
      );
    }
    if (isPayment) {
      return (
        <>
          <IconButton onClick={click} style={{ color: '#f78181' }}>
            <Icon icon={closeOutline} width={15} height={15} />
          </IconButton>
          <Box style={{ flex: 1 }}>
            {listPayment.map((row) => (
              <button
                className={classes.buttonP}
                style={{
                  backgroundColor: select === row.id ? '#f78181' : 'white',
                  color: select === row.id ? 'white' : '#f78181'
                }}
                onClick={() => setSelect(row.id)}
              >
                {t(row.name)}
              </button>
            ))}
          </Box>
          {select !== null && (
            <IconButton onClick={click1} style={{ color: '#54D62C' }}>
              <Icon icon={checkmarkFill} width={25} height={25} />
            </IconButton>
          )}
        </>
      );
    }
  };

  return (
    <RootStyle
      sx={{
        ...(numSelected > 0 && {
          color: 'primary.main',
          bgcolor: '#fff5f5'
        })
      }}
    >
      {numSelected > 0 ? (
        result(isPayment)
      ) : (
        <SearchStyle
          value={filterName}
          onChange={onFilterName}
          placeholder={holder}
          startAdornment={
            <InputAdornment position="start">
              <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
            </InputAdornment>
          }
        />
      )}
    </RootStyle>
  );
}
